// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "examples/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/4.jpg";
import team2 from "assets/images/5.jpg";
import team3 from "assets/images/6.jpg";
import team4 from "assets/images/7.jpg";
import team5 from "assets/images/8.jpg";
import team6 from "assets/images/9.jpg";
import team7 from "assets/images/10.jpg";
import team8 from "assets/images/2.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
              The Executive Team
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              There&apos;s Nothing I Really Wanted to Do in Life that I Wasn&apos;t Able to Get God
              at. That&apos;s My Skill.
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="LapZ-1"
                position={{ color: "info", label: "Cyber Security Engineer" }}
                description="Expert in safeguarding systems, identifying vulnerabilities, and implementing robust security protocols to protect data."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="LapZ-2"
                position={{ color: "info", label: "Software Engineer" }}
                description="Develops, tests, and maintains software applications, ensuring they meet user requirements and industry standards."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="LapZ-3"
                position={{ color: "info", label: "Databse Adminstrater" }}
                description="Manages, optimizes, and secures databases, ensuring data integrity, availability, and performance across the organization."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="LapZ-4"
                position={{ color: "info", label: "Ui/UX Engineer" }}
                description="Designs intuitive and engaging user interfaces, enhancing user experience through thoughtful interaction and visual design."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 1 }}>
              <HorizontalTeamCard
                image={team5}
                name="LapZ-5"
                position={{ color: "info", label: "AI Engineer" }}
                description="Builds intelligent systems using machine learning and AI algorithms to solve complex problems and drive innovation."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 1 }}>
              <HorizontalTeamCard
                image={team6}
                name="LapZ-6"
                position={{ color: "info", label: "QA Lead Engineer" }}
                description="Leads quality assurance efforts, ensuring software reliability and performance through rigorous testing and validation."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 2 }}>
              <HorizontalTeamCard
                image={team7}
                name="LapZ-7"
                position={{ color: "info", label: "Senior Software Engineer" }}
                description="Oversees development projects, mentoring junior developers and delivering high-quality software solutions efficiently."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 2 }}>
              <HorizontalTeamCard
                image={team8}
                name="LapZ-8"
                position={{ color: "info", label: "Blockchain Developer" }}
                description="Specializes in building decentralized applications and smart contracts using blockchain technology for secure transactions."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
